import { type ReactNode } from 'react'
import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'
import styles from './DraftApproved.module.css'

export interface DraftApprovedRetailActionsProps {
  isAnyExtensionFlowAvailable: boolean
  onAuthorizationReceived: () => unknown
  extensionActions?: ReactNode
}

export function DraftApprovedRetailActions({
  isAnyExtensionFlowAvailable,
  onAuthorizationReceived,
  extensionActions,
}: DraftApprovedRetailActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
        <Button
          label="Authorization was received"
          variant="primary"
          size="wide-slim"
          onPress={onAuthorizationReceived}
          testId="job-progression-set-authorization-received-button"
        />
      </CardContent>

      {extensionActions}
    </>
  )
}

export interface DraftApprovedOutsourcingActionsProps {
  isAnyExtensionFlowAvailable: boolean
  canCompleteJob?: boolean
  pendingActionsText: string
  onCompleteJob: () => unknown
  extensionActions?: ReactNode
}

export function DraftApprovedOutsourcingActions({
  isAnyExtensionFlowAvailable,
  canCompleteJob,
  pendingActionsText,
  onCompleteJob,
  extensionActions,
}: DraftApprovedOutsourcingActionsProps) {
  return (
    <>
      {!isAnyExtensionFlowAvailable && (
        <CardContent>
          <Button
            label="Complete Job"
            variant="primary"
            size="wide-slim"
            onPress={onCompleteJob}
            testId="job-progression-complete-job-button"
            isDisabled={!canCompleteJob}
          />
          {!canCompleteJob && (
            <div className={styles.pendingActions}>{pendingActionsText}</div>
          )}
        </CardContent>
      )}

      {extensionActions}
    </>
  )
}

export interface DraftApprovedReviewActionsProps {
  onReviewCompleted: () => unknown
}

export function DraftApprovedReviewActions({
  onReviewCompleted,
}: DraftApprovedReviewActionsProps) {
  return (
    <CardContent>
      <Button
        label="Review Completed"
        variant="primary"
        size="wide-slim"
        onPress={onReviewCompleted}
        testId="job-progression-set-upload-review-notes-button"
      />
    </CardContent>
  )
}
